import { host, wxConf } from '../config/env'
import delayLoad from './delayLoad'
import topic from '../api/topic'
import Vue from 'vue'
var wxJsSdk = null
function getUrl (url) {
  return url + (url.indexOf('?') > -1 ? '&' : '?') + '_product_code=W050009'
}
/**
 * 微信注册
 * @param redirectUrl
 */
function register (redirectUrl) {
  var serverUrl = host.passport + '/eqs/rel-account/wechat-mp?appId=' + wxConf.WX_APP_ID
  _hrefToWxAuth(serverUrl, getUrl(redirectUrl))
}

/**
 * 跳转至微信授权
 * @param serverUrl
 * @param redirectUrl
 */
function _hrefToWxAuth (serverUrl, redirectUrl) {
  var authHost = (/\/\/([^/]+)\//.exec(wxConf.AUTHORIZE_URL) || [])[1] || ''

  if (serverUrl.indexOf(authHost) > -1) {
    var url = serverUrl
  } else {
    url = `${wxConf.AUTHORIZE_URL}?server_uri=` + serverUrl
  }
  window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize' + '?appid=' + wxConf.WX_APP_ID +
    '&redirect_uri=' + encodeURIComponent(url) +
    '&response_type=code&scope=snsapi_userinfo' +
    '&state=' + encodeURIComponent(redirectUrl) + '#wechat_redirect'
}
function loadWxSdk () {
  return delayLoad.delayLoadJS(Vue.env.plugin.wxsdk)
}
function getWxShareInfo () {
  return topic.getWxShareInfo({
    shareUrl: window.location.href
  }).then(res => res.data)
}
function initWx () {
  if (wxJsSdk) {
    return wxJsSdk
  }
  wxJsSdk = Promise.all([loadWxSdk(), getWxShareInfo()]).then(datas => {
    let shareConfig = datas[1].obj
    return new Promise(function (resolve, reject) {
      window.wx.config({
        debug: false,
        appId: 'wx1c2251ce5fbdea98',
        timestamp: shareConfig.timestamp,
        nonceStr: shareConfig.noncestr,
        signature: shareConfig.signature,
        jsApiList: [
          'updateAppMessageShareData',
          'updateTimelineShareData',
          'onMenuShareWeibo'
        ]
      })
      window.wx.ready(function () {
        resolve()
      })
    })
  })
  return wxJsSdk
}
function setWxShareInfo ({ title, desc, link, imgUrl, success, cancel }) {
  return initWx()
    .then(() => {
      // 自定义“分享给朋友”及“分享到QQ”按钮的分享内容
      window.wx.updateAppMessageShareData({
        title, // 分享标题
        link, // 分享链接
        desc,
        imgUrl, // 分享图标
        success: function () {
          success && success()
        },
        cancel: function () {
          cancel && cancel()
        }
      })

      // 自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容
      window.wx.updateTimelineShareData({
        title, // 分享标题
        link, // 分享链接
        imgUrl, // 分享图标
        success: function () {
          success && success()
        },
        cancel: function () {
          cancel && cancel()
        }
      })

      // 分享到腾讯微博
      window.wx.onMenuShareWeibo({
        title, // 分享标题
        desc, // 分享描述
        link, // 分享链接
        imgUrl, // 分享图标
        success: function () {
          success && success()
        },
        cancel: function () {
          cancel && cancel()
        }
      })
    })
}

export {
  register,
  initWx,
  setWxShareInfo
}
